import * as v from "valibot";

import { rpcContract } from "../rpc";

export const verifyEmailRpcContract = rpcContract({
  paramsSchema: v.object({
    email: v.pipe(v.string(), v.email()),
    token: v.string(),
    purchaseEventHandle: v.optional(v.string()),
    purchaseEventId: v.optional(v.string()),
  }),
  resultSchema: v.object({
    accessToken: v.string(),
    purchaseEventHandle: v.optional(v.string()),
    purchaseEventId: v.optional(v.string()),
  }),
  name: "verify-email",
});

export type VerifyEmailParams = v.InferOutput<(typeof verifyEmailRpcContract)["paramsSchema"]>;
export type VerifyEmailResult = v.InferOutput<(typeof verifyEmailRpcContract)["resultSchema"]>;
export enum VerifyEmailErrorMessages {
  InvalidToken = "invalid-token",
  AlreadyVerified = "already-verified",
}
